import { Box } from '@origin-digital/style-guide';
import * as React from 'react';

import NavItem from './NavItem';

const Navigation: React.StatelessComponent<NavigationProps> = ({ onChange, view }: NavigationProps) => {
  return (
    <Box direction={'row'} display={'flex'} justifyContent={'center'} marginBottom={10} marginTop={6}>
      <NavItem data-id={'QuoteRequestSelect'} type={'request'} text={'Quote request'} view={view} iconType={'phone'} onChange={onChange} />
      <NavItem data-id={'ServiceRequestSelect'} type={'general'} text={'Service request'} view={view} iconType={'build'} onChange={onChange} />
    </Box>
  );
};

export { Navigation as default };
